export default {

    type: '',
}
